import DeleteUserForm, { Props } from '@Components/DeleteUser/DeleteUserForm';
import React, { PropsWithRef, RefObject, forwardRef, useCallback } from 'react';

import { Modal } from '@mui/material';
import { StyledModal } from './EntitlementsTable.styles';
/* eslint-disable @typescript-eslint/ban-types */
import { deleteUser } from '@Actions/users';
import { useDispatch } from 'react-redux';

interface DeleteUserModalProps {
	userID?: string;
	userName: string;
	isModalOpen: boolean;
	setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeleteUserModal = ({
	userID,
	userName,
	isModalOpen,
	setIsModalOpen,
}: DeleteUserModalProps) => {
	const dispatch = useDispatch();
	const closeDeleteModal = () => setIsModalOpen(false);
	const handleDeleteUser = useCallback(() => {
		if (userID) dispatch(deleteUser(userID));
		setIsModalOpen(false);
	}, [userID]);

	const DeleteUser = (
		props: Props,
		ref:
			| ((instance: HTMLDivElement | null) => void)
			| RefObject<HTMLDivElement>
			| null,
	) => {
		return (
			<StyledModal ref={ref}>
				<DeleteUserForm {...props} />
			</StyledModal>
		);
	};

	const DeleteModal = forwardRef<
		HTMLDivElement,
		PropsWithRef<{
			cancel: () => void;
			deleteUser: () => void;
			username: string;
		}>
	>(DeleteUser);
	return (
		<Modal open={isModalOpen} onClose={closeDeleteModal}>
			<DeleteModal
				cancel={closeDeleteModal}
				deleteUser={handleDeleteUser}
				username={userName}
			/>
		</Modal>
	);
};

export default DeleteUserModal;
